export const ACCEPTED_IMAGE_TYPES = new Set([".png", ".jpg", ".jpeg"]);
export const ACCEPTED_IMAGE_MIME = new Set(["image/png", "image/jpeg", "image/jpg"]);
export const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;
export const MAX_IMAGES_PER_COMMENT = 3;

export const ACCEPTED_IMAGE_ACCEPT: Record<string, string[]> = {
    "image/png": [".png"],
    "image/jpeg": [".jpg", ".jpeg"],
};

export const RAISE_ESCALATION_PLACEHOLDER_TEXT = 'Optional: Let your team know why you are raising this escalation. Enter the reason for escalation';
export const STATUS_CHANGE_PLACEHOLDER_TEXT = 'Optional: Let your team know why you are changing the escalation status';

export const OPPORTUNITY_UID_KEY = 'opportunityUid';
export const APPLICATION_ESCALATION_UID_KEY = 'applicationEscalationUid';   
export const COMMENT_TYPE_KEY = 'commentType';
export const COMMENT_KEY = 'comment';
export const FILES_KEY = 'files';
export const ESCALATION_STATUS_KEY = 'escalationStatus'; 
export const UPDATE_IN_EMAIL_THREAD_KEY = 'updateInEmailThread';